import * as Yup from "yup";
import { LABELS, NAMES } from "./Config";

let { GOAL_NAME, GOAL_ORDER, GOAL_TYPE, STATUS, SUB_CATEGORY } = LABELS;

export const initialValues = {
    GoalForm: {
        [NAMES[GOAL_NAME]]: "",
        [NAMES[GOAL_ORDER]]: "",
        [NAMES[GOAL_TYPE]]: null,
        [NAMES[SUB_CATEGORY]]: null,
        [NAMES[STATUS]]: ""
    }
};

export const GOAL_VALIDATION_SCHEMA = Yup.object({
    [NAMES[GOAL_NAME]]: Yup.string().required("Please enter the Name"),
    [NAMES[GOAL_ORDER]]: Yup.number().required("Please select the Goal Order"),
    [NAMES[GOAL_TYPE]]: Yup.object().required("Please select the Goal Type"),
    [NAMES[SUB_CATEGORY]]: Yup.array()
        .min(1, "Please select at least one Sub Category")
        .required("Please select the Sub Category"),
    [NAMES[STATUS]]: Yup.string().required("Please select Goal Status")
});
